import { createLogic } from 'redux-logic';
// common
import { globalCleanReports } from '../../common/actions';
// features
import { sendLogOutRequest } from '../auth/actions';
import { receivedSwitchBranchSuccess } from '../branch/actions';
// feature toll charges
import { setInitialState } from './actions';
//////////////////////////////////////////////////

export const handleSwitchBranchLogic = createLogic({
  type: [
    sendLogOutRequest,
    globalCleanReports,
    receivedSwitchBranchSuccess,
  ],
  validate({ getState, action }, allow) {
    allow(action);
  },
  process({ getState, action }, dispatch, done) {
    dispatch(setInitialState());
    done();
  },
});

export default [handleSwitchBranchLogic];
